import { useFirestore, useFirestoreDocData, useUser } from 'reactfire'
import { doc } from 'firebase/firestore'

export function useAgentSoundEnabled(): boolean {
  const firestore = useFirestore()
  const { data: user } = useUser()
  const uid = user?.uid ?? '_placeholder'

  const { data: profile } = useFirestoreDocData(
    doc(firestore, 'userprofiles', uid)
  )

  const agentSettings = (profile as any)?.notificationSettings?.agent
  return agentSettings?.sound_enabled !== false
}
